import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import ROUTES from 'constants/routes'
import DropDown from './DropDown'
import Footer from './Footer'

function MenuLanding({ hideMenu }) {
  const { t } = useTranslation()
  const history = useHistory()

  function handleClick(to) {
    hideMenu()
    history.push(to)
  }

  return (
    <div className="menu-landing menu-landing--open">
      <div className="menu-landing__list">
        <div className="menu-landing__item menu-landing__item--top-margin">
          <Link exact onClick={() => handleClick(ROUTES.LANDING_HOME)} className="menu-landing__link">
            {t('landing.header.home')}
          </Link>
        </div>
        <div className="menu-landing__item">
          <Link
            exact
            onClick={() => handleClick(ROUTES.LANDING_GAME_OVERVIEW)}
            className="menu-landing__link"
          >
            {t('landing.header.game_overview')}
          </Link>
        </div>
        <div className="menu-landing__item">
          <Link exact onClick={() => handleClick(ROUTES.LANDING_ABOUT)} className="menu-landing__link">
            {t('landing.header.about')}
          </Link>
        </div>
      </div>
      <div className="menu-landing__item menu-landing__item--top-margin">
        <DropDown variant="mobile" />
      </div>
      <div className="menu-landing__item-last">
        <Footer />
      </div>
    </div>
  )
}

MenuLanding.propTypes = {
  hideMenu: PropTypes.func.isRequired
}

export default MenuLanding
